export const translations = {
  en: {
    meta: {
      title: "NEXA - AI-Powered Digital Workforce Platform",
      description: "Transform your business with NEXA's AI-powered digital workforce platform. Automate tasks, streamline workflows, and boost productivity with our intelligent digital workers.",
      keywords: "AI, digital workforce, automation, business intelligence, workflow automation, digital transformation, artificial intelligence, machine learning"
    },
    footer: {
      copyright: "Copyright",
      becomeMentor: "Become a Mentor",
      share: "Share",
      shareWithColleagues: "Share with your colleagues",
      copyrightText: "NEXA. All rights reserved.",
      backgroundImage: "https://cdn.nexastaff.ai/back.jpg",
      shareText: "Check out this amazing platform!",
      shareAria: {
        twitter: "Share on Twitter",
        linkedin: "Share on LinkedIn",
        facebook: "Share on Facebook",
        email: "Share via Email"
      }
    }
  },
  fr: {
    meta: {
      title: "NEXA - Plateforme de Main-d'œuvre Numérique Alimentée par l'IA",
      description: "Transformez votre entreprise avec la plateforme de main-d'œuvre numérique NEXA alimentée par l'IA. Automatisez les tâches, rationalisez les flux de travail et augmentez la productivité avec nos travailleurs numériques intelligents.",
      keywords: "IA, main-d'œuvre numérique, automatisation, intelligence d'affaires, automatisation des flux de travail, transformation numérique, intelligence artificielle, apprentissage automatique"
    },
    footer: {
      copyright: "Droits d'auteur",
      becomeMentor: "Devenir Mentor",
      share: "Partager",
      shareWithColleagues: "Partagez avec vos collègues",
      copyrightText: "NEXA. Tous droits réservés.",
      backgroundImage: "https://cdn.nexastaff.ai/back.jpg",
      shareText: "Découvrez cette plateforme incroyable !",
      shareAria: {
        twitter: "Partager sur Twitter",
        linkedin: "Partager sur LinkedIn",
        facebook: "Partager sur Facebook",
        email: "Partager par courriel"
      }
    }
  },
  // Add other languages as needed
}; 